<template>
    <Modal :title="'【'+waybill.orderId+','+waybill.waybillOrder+'】包裹记录'" :width="1200" @on-visible-change="showModal" v-model="show" :closable="false" :mask-closable="false">
        <div v-if="state==-1||state==-2" style="margin-bottom:10px">
            <label>请输入【{{waybillExpress.expressNo}}{{state==-1?"退回":"取消"}}】备注：</label><Input style="width: 240px;" v-model="remark" /><el-button size="small" type="primary" @click="toback">确定提交</el-button>
        </div>
        <Table :loading="loading" :columns="columns" :data="waybillExpresss" border>
        </Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" @click="ok">确定</el-button>
        </div>
    </Modal>
</template>
<script>
export default {
    name: "",
    data() {
        return {
            visible:false,
         
            loading: false,
            waybillExpress: {},
            waybillExpresss: [],
            queryParams: {

            },
            state: 0,
            remark: "",
            columns: [{
                    title: '快递',
                    key: 'expressName',
                    width: 160,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var divs = [];
                        divs.push(h("div", {}, row.expressName));
                        divs.push(h("div", {}, "单号：" + row.expressNo));
                        return h("div", { props: {}, style: {} }, divs);

                    }
                }, {
                    title: '商品图片',
                    key: 'outOrderNo',
                    width: 280,
                    align: 'center',
                    render: (h, params) => {
                        var me=this;
                        var row = params.row;
                        var divs = [];
                        var divimages = [];
                        var ps = row.pics.split("##");

                        for (var i = 0; i < ps.length; i++) {

                            if (ps[i] != '') {
                                var imgs = [];
                                imgs.push(h("img", { style: {  }, attrs: { src: ps[i] },on:{
                                  click:(e)=>{
                                  
                                    var t=e.currentTarget.currentSrc;
                                   
                                    var title=row.expressName+":"+row.expressNo;
                                    me.showImage(t,title);
                                  }  
                                } }));
                                divimages.push(h("div", { class: ["demo-upload-list"] }, imgs));
                            }
                        }
                        if (divimages.length > 0) {
                          
                             return h("div", { props: {}, style: {float:"left"} }, divimages);
                        } else {
                           return  h("div", { props: {}, style: {} }, "暂无图片");
                        }

                       

                    }
                },{
                    title: '备注',
                    key: 'remark',
                    width: 280,
                    align: 'center'
                },{
                    title: '状态',
                    key: 'state',
                    width: 190,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var spans = [];
                        var me = this;
                        spans.push(h("div", "创建：" + me.long2datetime(params.row.createTime)));

                        var text = "待签收";
                        var styles = { color: '#fff', padding: '2px' };
                        styles.backgroundColor = "#2db7f5";
                        if (row.state == -2) {
                            text = "已取消";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "取消：" + me.long2datetime(params.row.cancelTime)));
                        } else if (row.state == 1) {
                            text = "已签收";
                            styles.backgroundColor = "#19be6b";
                            spans.push(h("div", "签收：" + me.long2datetime(params.row.signTime)));
                        } else if (row.state == -1) {
                            text = "拒签退回";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "退回：" + me.long2datetime(params.row.cancelTime)));
                        }
                        spans.push(h("div", { style: styles }, text));

                        return h("div", { style: { padding: "10px 0px" } }, spans);
                    }
                }, {
                    title: '外部订单号（淘宝阿里）',
                    key: 'outOrderNo',
                    width: 180,
                    align: 'center'
                },  {
                    title: '操作',
                    key: 'state',
                    width: 180,
                    align: 'center',

                    fixed: 'left',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];
                        if (row.state == 0) {
                            btns.push(
                                h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "primary" }, on: { click: () => {this.sign(row)} } }, "签收"));
                            btns.push(
                                h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.waybillExpress = row;
                                            this.state = -2; } } }, "取消"));
                          
                        }
                        if(row.state==1)
                          btns.push(
                                h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.waybillExpress = row;
                                            this.state = -1; } } }, "未签收退回"));

                            return h("div", btns);
                    }
                }

            ],
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
        }
    },
    props: [
        'show',  'waybill'
    ],
    methods: {
        showModal: function(val) {
            if (val) this.getList();

        },
        toback:function(){ var me = this;
            if(me.remark=="")
            {
                me.errorMessage("请输入备注！");
                return ;
            }
            var url="/ware/waybillexpress/back.action";
            if(me.state==-1) url="/ware/waybillexpress/unsign.action";
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post(url, {state:me.state, id: me.waybillExpress.id,remark:me.remark}).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            params.waybillId = me.waybill.id;
            me.loading = true;
           
            me.$http.post("/ware/waybillexpress/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.waybillExpresss = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        ok: function() {
            this.$emit('ok');
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        cancel: function() {
            this.$emit('cancel')
        },
       showImage:function(url,title){
this.$emit('showImage',url,title);
},
        sign:function(row){
             var me = this;

            me.$Modal.confirm({
                title: "提示",
                content: "是否确定签收该包裹操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/waybillexpress/sign.action", { id: row.id }).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        }

    }
}
</script>
<style scoped>
.time {
    font-size: 14px;
    font-weight: bold;
}

.content {
    padding-left: 5px;
    word-wrap: break-word;
}
</style>